import "./RestrictedRouteComponent.scss";
import ButtonComponent from "../core/button/ButtonComponent";
import {useNavigate} from "react-router-dom";
import {CommonService} from "../../services";
import * as React from "react";
import {ImageConfig} from "../../../constants";
import LottieFileGenarationComponent from "../core/lottie-file-genaration/LottieFileGenarationComponent";

interface RestrictedRouteComponentProps {

}

const RestrictedRouteComponent = (props: RestrictedRouteComponentProps) => {
    const navigate = useNavigate();

    return (
        <div className={'restricted-route-component'}>
            <div className={'lottie-wrapper'}>
                <LottieFileGenarationComponent
                    height={'200px'}
                    width={'200px'}
                    loop={true}
                    autoplay={true}
                    animationData={ImageConfig.accessDeniedLottie}/>
            </div>
            <div className={'restricted-route-title'}>
                Access Denied!
            </div>
            <div className={'restricted-route-description'}>
                The page you are trying to view is having restricted access. Refer to your system administrator for
                assistance.
            </div>
            <div className={'restricted-page-action-wrapper'}>
                <ButtonComponent
                    handleClick={() => navigate(CommonService._routeConfig.Dashboard())}
                    variant={"contained"}
                    color={"primary"}
                >
                    Back to Dashboard
                </ButtonComponent>
            </div>

        </div>
    );

};

export default RestrictedRouteComponent;
